import { gql } from 'apollo-boost';

export const ValidationErrorFragment = gql`
    fragment ValidationErrorFragment on GdDefect {
        code
        params
        path
    }
`;

export const ValidationWarningFragment = gql`
    fragment ValidationWarningFragment on GdDefect {
        code
        params
        path
    }
`;

export const ValidationResultFragment = gql`
    fragment ValidationResultFragment on GdValidationResult {
        errors {
            ...ValidationErrorFragment
        }
        warnings {
            ...ValidationWarningFragment
        }
    }
    ${ValidationWarningFragment}
    ${ValidationErrorFragment}
`;
